(() => {
  const replaceTag = (element, tagName) => {
    if (!element || element.tagName.toLowerCase() === tagName) return element;

    const replacement = document.createElement(tagName);
    [...element.attributes].forEach((attribute) => {
      replacement.setAttribute(attribute.name, attribute.value);
    });
    while (element.firstChild) replacement.appendChild(element.firstChild);
    element.replaceWith(replacement);
    return replacement;
  };

  const addContactLink = (list, mobile = false) => {
    if (!list || list.querySelector('a[href="/pages/contact"]')) return;

    const item = document.createElement('li');
    const link = document.createElement('a');
    link.href = '/pages/contact';
    link.textContent = 'Contact';
    link.className = mobile
      ? 'menu-drawer__menu-item list-menu__item link link--text focus-inset'
      : 'header__menu-item list-menu__item link link--text focus-inset';
    item.appendChild(link);
    list.appendChild(item);
  };

  const improveHeaderSemantics = () => {
    if (window.location.pathname !== '/') return;

    document.querySelectorAll('h1.header__heading').forEach((heading) => {
      replaceTag(heading, 'div');
    });
    replaceTag(document.querySelector('main .banner__heading'), 'h1');
  };

  const improveImageAlts = () => {
    document.querySelectorAll('.image-with-text').forEach((section) => {
      const image = section.querySelector('img:not([alt]), img[alt=""]');
      const heading = section.querySelector('.image-with-text__heading');
      if (image && heading) image.alt = heading.textContent.trim();
    });
  };

  const cleanOrganizationSchema = () => {
    document.querySelectorAll('script[type="application/ld+json"]').forEach((script) => {
      try {
        const data = JSON.parse(script.textContent);
        if (data['@type'] === 'Organization' && Array.isArray(data.sameAs)) {
          data.sameAs = data.sameAs.filter(Boolean);
          script.textContent = JSON.stringify(data);
        }
      } catch (_error) {
        // Leave third-party or non-JSON structured data untouched.
      }
    });
  };

  const syncSocialMetadata = () => {
    const description = document.querySelector('meta[name="description"]')?.content;
    const values = {
      'og:title': document.title,
      'twitter:title': document.title,
      'og:description': description,
      'twitter:description': description,
    };

    Object.entries(values).forEach(([name, value]) => {
      if (!value) return;
      const selector = name.startsWith('og:')
        ? `meta[property="${name}"]`
        : `meta[name="${name}"]`;
      const meta = document.querySelector(selector);
      if (meta) meta.content = value;
    });
  };

  document.addEventListener('DOMContentLoaded', () => {
    improveHeaderSemantics();
    addContactLink(document.querySelector('.header__inline-menu > .list-menu--inline'));
    addContactLink(document.querySelector('.menu-drawer__menu.has-submenu'), true);
    improveImageAlts();
    cleanOrganizationSchema();
    syncSocialMetadata();
  });
})();
